const API_BASE_URL = process.env.REACT_APP_BASE_API_URL


export const deleteAffiliate = async (id) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API_BASE_URL}/admin/user/affiliator-accounts/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error('Ошибка при удалении аффилиата');
      }
  
      console.log(`Аффилиат с ID ${id} удалён`);
    } catch (error) {
      console.error('Ошибка при удалении:', error);
      throw error;
    }
  };